/** Ant Design Pro strings for tg-TJ (no built-in locale — avoids zh-CN fallback) */
export default {
  moneySymbol: 'смн',
  form: {
    lightFilter: {
      more: 'Филтрҳои бештар',
      clear: 'Тоза кардан',
      confirm: 'OK',
      itemUnit: 'адад',
    },
  },
  tableForm: {
    search: 'Ҷустуҷӯ',
    reset: 'Танзими дубора',
    submit: 'Ирсол',
    collapsed: 'Кушодан',
    expand: 'Печонидан',
    inputPlaceholder: 'Лутфан ворид кунед',
    selectPlaceholder: 'Лутфан интихоб кунед',
  },
  alert: {
    clear: 'Тоза кардан',
    selected: 'Интихобшуда',
    item: 'адад',
  },
  pagination: {
    total: {
      range: ' ',
      total: 'аз',
      item: 'сабт',
    },
  },
  tableToolBar: {
    leftPin: 'Часпонидан ба чап',
    rightPin: 'Часпонидан ба рост',
    noPin: 'Кушодан',
    leftFixedTitle: 'Дар чап ҷойгир',
    rightFixedTitle: 'Дар рост ҷойгир',
    noFixedTitle: 'Ҷойгирнашуда',
    reset: 'Танзими дубора',
    columnDisplay: 'Сутунҳо',
    columnSetting: 'Танзимоти сутун',
    fullScreen: 'Пурэкран',
    exitFullScreen: 'Баромад аз пурэкран',
    reload: 'Навсозӣ',
    density: 'Зичӣ',
    densityDefault: 'Муқаррарӣ',
    densityLarger: 'Васеъ',
    densityMiddle: 'Миёна',
    densitySmall: 'Зич',
  },
  stepsForm: {
    next: 'Баъдӣ',
    prev: 'Қаблӣ',
    submit: 'Анҷом',
  },
  loginForm: {
    submitText: 'Ворид шудан',
  },
  editableTable: {
    action: {
      save: 'Захира',
      cancel: 'Бекор кардан',
      delete: 'Нест кардан',
      add: 'Илова кардан',
    },
  },
  switch: {
    open: 'Фаъол',
    close: 'Ғайрифаъол',
  },
};
